"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.fetchOptInStatus = exports.redirect = void 0;

var _empty = require("rxjs/observable/empty");

var _filter = require("rxjs/operators/filter");

var _tap = require("rxjs/operators/tap");

var _mergeMapTo = require("rxjs/operators/mergeMapTo");

var _reduxObservable = require("redux-observable");

var _actions = require("./actions");

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _API = _interopRequireDefault(require("./API"));

var _selectors = require("./selectors");

var _hubspot = _interopRequireDefault(require("hubspot.PortalIdParser"));

var redirect = function redirect($action) {
  return $action.ofType(_actions.FetchOptInStatusActionTypes.FAILURE, _actions.FetchOptInStatusActionTypes.SUCCESS).pipe((0, _filter.filter)(function (action) {
    return action.type !== _actions.FetchOptInStatusActionTypes.SUCCESS || action.payload.data.status !== 'COMPLETED';
  }), (0, _tap.tap)(function () {
    window.location = "/settings/" + _hubspot.default.get() + "/users";
  }), (0, _mergeMapTo.mergeMapTo)((0, _empty.empty)()));
};

exports.redirect = redirect;
var fetchOptInStatus = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getStatus,
  initiatingActionType: _actions.OptInActionTypes.FETCH_OPT_IN_STATUS,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED],
  requestActions: _actions.FetchOptInStatus,
  requestStatusSelector: _selectors.getFetchOptInStatusRequestStatus
}));
exports.fetchOptInStatus = fetchOptInStatus;

var _default = (0, _reduxObservable.combineEpics)(redirect, fetchOptInStatus);

exports.default = _default;